module.exports = __webpack_public_path__ + "img/59aa5141dd79d0b9b12d4b687de82af5.png";